import { downloadOrderDocuments } from "apis/v3/orderApi";
import {
  trackResultsDownloadCompleted,
  trackResultsDownloadFailed
} from "analytics";
import { downloadFile } from "./fileUtils";
import { AxiosError } from "axios";

export const downloadDocument = async (
  orderId: string,
  documentId: string
): Promise<void> => {
  try {
    const response = await downloadOrderDocuments(orderId, documentId);
    if (response instanceof AxiosError) {
      throw response;
    }
    downloadFile(documentId, response.data);
    trackResultsDownloadCompleted({ documentId, orderId });
  } catch (error) {
    trackResultsDownloadFailed({ documentId, orderId, error });
  }
};
